import { create } from 'zustand';

interface PreferencesStore {
  developerMode: boolean;
  toggleDeveloperMode: () => void;
  setDeveloperMode: (enabled: boolean) => void;
}

/**
 * Zustand store for user preferences with localStorage persistence.
 *
 * Reason: Using manual localStorage instead of zustand/persist middleware
 * to keep the implementation lightweight for a single boolean preference.
 */
export const usePreferencesStore = create<PreferencesStore>((set) => ({
  developerMode: localStorage.getItem('developerMode') === 'true',
  toggleDeveloperMode: () =>
    set((state) => {
      const next = !state.developerMode;
      localStorage.setItem('developerMode', String(next));
      return { developerMode: next };
    }),
  setDeveloperMode: (enabled: boolean) => {
    localStorage.setItem('developerMode', String(enabled));
    set({ developerMode: enabled });
  },
}));
